import React, { useMemo } from 'react';
import locales from '../../../../../content.json';
import { getParameterFromURL } from '../../../../../utils/scripts';
import s from './index.module.scss';

import img1Png from './img/img.png';
import img1Webp from './img/img.webp';
import img2Png from './img/img2.png';
import img2Webp from './img/img2.webp';
import img1EsAvif from './img/img-es.avif';
import img1EsPng from './img/img-es.png';
import img2EsAvif from './img/img2-es.avif';
import img2EsPng from './img/img2-es.png';
import img2ItAvif from './img/img2-it.avif';
import img2ItPng from './img/img2-it.png';
import img2DeAvif from './img/img2-de.avif';
import img2DePng from './img/img2-de.png';
import img2FrAvif from './img/img2-fr.avif';
import img2FrPng from './img/img2-fr.png';
import img2TrAvif from './img/img2-tr.avif';
import img2TrPng from './img/img2-tr.png';

import img1PngDark from './img/imgDark.png';
import img1WebpDark from './img/imgDark.webp';
import img2PngDark from './img/img2Dark.png';
import img2WebpDark from './img/img2Dark.webp';

// Localized puppy book covers (avif + png). Languages not listed fall back to the default English image.
const localizedPuppyImg: Record<string, { avif: string; png: string }> = {
  es: { avif: img2EsAvif, png: img2EsPng },
  it: { avif: img2ItAvif, png: img2ItPng },
  de: { avif: img2DeAvif, png: img2DePng },
  fr: { avif: img2FrAvif, png: img2FrPng },
  tr: { avif: img2TrAvif, png: img2TrPng },
};

export const Header = () => {
  const role = getParameterFromURL('role');
  const darkTheme = getParameterFromURL('darkTheme');

  const title = useMemo(() => {
    if (role === 'puppy') {
      return locales[window.userLang].pdfUpselling_2;
    } else {
      return locales[window.userLang].pdfUpselling_1;
    }
  }, [role, window.userLang]);

  const img = useMemo(() => {
    if (role === 'puppy') {
      const localized = localizedPuppyImg[window.userLang];

      if (localized) {
        return (
          <picture className={s.img}>
            <source srcSet={localized.avif} type="image/avif" />
            <img src={localized.png} alt="dog training" />
          </picture>
        );
      }

      return (
        <picture className={s.img}>
          <source srcSet={darkTheme ? img2WebpDark : img2Webp} type="image/webp" />
          <img src={darkTheme ? img2PngDark : img2Png} alt="dog training" />
        </picture>
      );
    } else {
      if (window.userLang === 'es') {
        return (
          <picture className={s.img}>
            <source srcSet={img1EsAvif} type="image/avif" />
            <img src={img1EsPng} alt="dog training" />
          </picture>
        );
      }

      return (
        <picture className={s.img}>
          <source srcSet={darkTheme ? img1WebpDark : img1Webp} type="image/webp" />
          <img src={darkTheme ? img1PngDark : img1Png} alt="dog training" />
        </picture>
      );
    }
  }, [role, window.userLang, darkTheme]);

  return (
    <div className={s.wrapper}>
      <h2 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
      {img}
    </div>
  );
};